var _rect, _text, _text2, _g, _line, _polygon, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _line2, _polygon2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgObianFig1FourLayerRouter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1200 620",
    fontFamily: "Geist, 'Segoe UI', -apple-system, sans-serif",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1200,
    height: 620,
    fill: "#FFFDF7"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 48,
    y: 52,
    fontSize: 22,
    fontWeight: 600,
    fill: "#1A2F2A"
  }, "The four-layer router")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 48,
    y: 76,
    fontSize: 14,
    fill: "#4A5F56"
  }, "Every name takes the cheapest path that answers, and an unresolvable name fails closed")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 120,
    width: 240,
    height: 64,
    rx: 10,
    fill: "#FFFFFF",
    stroke: "#1A2F2A",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("text", {
    x: 168,
    y: 147,
    fontSize: 13.5,
    fontWeight: 600,
    fill: "#1A2F2A",
    textAnchor: "middle"
  }, "URL bar input"), /*#__PURE__*/React.createElement("text", {
    x: 168,
    y: 168,
    fontSize: 12,
    fill: "#6B7F74",
    textAnchor: "middle",
    fontFamily: "Consolas, monospace"
  }, "example.com &#183; thubble.x &#183; name.eth"))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 168,
    y1: 184,
    x2: 168,
    y2: 222,
    stroke: "#9AA9A1",
    strokeWidth: 1.5
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "168,228 163,219 173,219",
    fill: "#9AA9A1"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 232,
    width: 360,
    height: 66,
    rx: 10,
    fill: "#FFFFFF",
    stroke: "#7C3AED",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("text", {
    x: 66,
    y: 258,
    fontSize: 12,
    fontWeight: 600,
    fill: "#7C3AED"
  }, "1  SCHEME PREFIX"), /*#__PURE__*/React.createElement("text", {
    x: 66,
    y: 280,
    fontSize: 11.5,
    fill: "#4A5F56",
    fontFamily: "Consolas, monospace"
  }, "dns:// ens:// ud:// hns:// fn:// force one resolver"))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 312,
    width: 360,
    height: 66,
    rx: 10,
    fill: "#FFFFFF",
    stroke: "#7C3AED",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("text", {
    x: 66,
    y: 338,
    fontSize: 12,
    fontWeight: 600,
    fill: "#7C3AED"
  }, "2  TLD HINT"), /*#__PURE__*/React.createElement("text", {
    x: 66,
    y: 360,
    fontSize: 11.5,
    fill: "#4A5F56"
  }, "permanent (IANA, UD, Freename) plus learned hints skip the cascade"))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 392,
    width: 700,
    height: 110,
    rx: 10,
    fill: "#F7FAF8",
    stroke: "#16A34A",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("text", {
    x: 66,
    y: 418,
    fontSize: 12,
    fontWeight: 600,
    fill: "#16A34A"
  }, "3  CASCADE, EVERY FAILURE FALLS THROUGH"), /*#__PURE__*/React.createElement("g", {
    fontSize: 12.5,
    fontWeight: 600,
    fill: "#1A2F2A",
    textAnchor: "middle"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 66,
    y: 434,
    width: 110,
    height: 44,
    rx: 8,
    fill: "#FFFFFF",
    stroke: "#E2E8E4",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("text", {
    x: 121,
    y: 454
  }, "DNS"), /*#__PURE__*/React.createElement("text", {
    x: 121,
    y: 470,
    fontSize: 10,
    fontWeight: 400,
    fill: "#6B7F74"
  }, "all ICANN"), /*#__PURE__*/React.createElement("rect", {
    x: 196,
    y: 434,
    width: 110,
    height: 44,
    rx: 8,
    fill: "#FFFFFF",
    stroke: "#E2E8E4",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("text", {
    x: 251,
    y: 454
  }, "Handshake"), /*#__PURE__*/React.createElement("text", {
    x: 251,
    y: 470,
    fontSize: 10,
    fontWeight: 400,
    fill: "#6B7F74"
  }, "523+ TLDs"), /*#__PURE__*/React.createElement("rect", {
    x: 326,
    y: 434,
    width: 110,
    height: 44,
    rx: 8,
    fill: "#FFFFFF",
    stroke: "#E2E8E4",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("text", {
    x: 381,
    y: 454
  }, "Freename"), /*#__PURE__*/React.createElement("text", {
    x: 381,
    y: 470,
    fontSize: 10,
    fontWeight: 400,
    fill: "#6B7F74"
  }, "catch-all"), /*#__PURE__*/React.createElement("rect", {
    x: 456,
    y: 434,
    width: 110,
    height: 44,
    rx: 8,
    fill: "#FFFFFF",
    stroke: "#E2E8E4",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("text", {
    x: 511,
    y: 454
  }, "Unstoppable"), /*#__PURE__*/React.createElement("text", {
    x: 511,
    y: 470,
    fontSize: 10,
    fontWeight: 400,
    fill: "#6B7F74"
  }, "137 TLDs"), /*#__PURE__*/React.createElement("rect", {
    x: 586,
    y: 434,
    width: 110,
    height: 44,
    rx: 8,
    fill: "#FFFFFF",
    stroke: "#E2E8E4",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("text", {
    x: 641,
    y: 454
  }, "ENS"), /*#__PURE__*/React.createElement("text", {
    x: 641,
    y: 470,
    fontSize: 10,
    fontWeight: 400,
    fill: "#6B7F74"
  }, ".eth")), /*#__PURE__*/React.createElement("g", {
    stroke: "#9AA9A1",
    strokeWidth: 1.2
  }, /*#__PURE__*/React.createElement("line", {
    x1: 176,
    y1: 456,
    x2: 196,
    y2: 456
  }), /*#__PURE__*/React.createElement("line", {
    x1: 306,
    y1: 456,
    x2: 326,
    y2: 456
  }), /*#__PURE__*/React.createElement("line", {
    x1: 436,
    y1: 456,
    x2: 456,
    y2: 456
  }), /*#__PURE__*/React.createElement("line", {
    x1: 566,
    y1: 456,
    x2: 586,
    y2: 456
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 516,
    width: 360,
    height: 56,
    rx: 10,
    fill: "#FFFFFF",
    stroke: "#DC2626",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("text", {
    x: 66,
    y: 540,
    fontSize: 12,
    fontWeight: 600,
    fill: "#DC2626"
  }, "4  FAIL CLOSED"), /*#__PURE__*/React.createElement("text", {
    x: 66,
    y: 560,
    fontSize: 11.5,
    fill: "#4A5F56",
    fontFamily: "Consolas, monospace"
  }, "\"Cannot resolve &lt;name&gt;\""))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    stroke: "#9AA9A1",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("line", {
    x1: 228,
    y1: 298,
    x2: 228,
    y2: 312
  }), /*#__PURE__*/React.createElement("line", {
    x1: 228,
    y1: 378,
    x2: 228,
    y2: 392
  }), /*#__PURE__*/React.createElement("line", {
    x1: 228,
    y1: 502,
    x2: 228,
    y2: 516
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 812,
    y: 232,
    width: 340,
    height: 120,
    rx: 10,
    fill: "#FFFFFF",
    stroke: "#16A34A",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("text", {
    x: 982,
    y: 262,
    fontSize: 13.5,
    fontWeight: 600,
    fill: "#16A34A",
    textAnchor: "middle"
  }, "ContentPointer"), /*#__PURE__*/React.createElement("text", {
    x: 982,
    y: 286,
    fontSize: 11.5,
    fill: "#4A5F56",
    textAnchor: "middle",
    fontFamily: "Consolas, monospace"
  }, "IPFS CID &#183; IPNS name &#183; Arweave TX"), /*#__PURE__*/React.createElement("text", {
    x: 982,
    y: 304,
    fontSize: 11.5,
    fill: "#4A5F56",
    textAnchor: "middle",
    fontFamily: "Consolas, monospace"
  }, "HTTP URL &#183; AgentManifest (.agt)"), /*#__PURE__*/React.createElement("text", {
    x: 982,
    y: 334,
    fontSize: 11,
    fill: "#6B7F74",
    textAnchor: "middle"
  }, "fetched over HTTP, IPFS, or Arweave"))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 812,
    y: 392,
    width: 340,
    height: 110,
    rx: 10,
    fill: "#FFFFFF",
    stroke: "#E2E8E4",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("text", {
    x: 982,
    y: 422,
    fontSize: 13,
    fontWeight: 600,
    fill: "#1A2F2A",
    textAnchor: "middle"
  }, "Adaptive hints"), /*#__PURE__*/React.createElement("text", {
    x: 982,
    y: 446,
    fontSize: 11.5,
    fill: "#4A5F56",
    textAnchor: "middle"
  }, "an unhinted TLD pays one fast miss,"), /*#__PURE__*/React.createElement("text", {
    x: 982,
    y: 464,
    fontSize: 11.5,
    fill: "#4A5F56",
    textAnchor: "middle"
  }, "then routes straight to its resolver"), /*#__PURE__*/React.createElement("text", {
    x: 982,
    y: 488,
    fontSize: 10.5,
    fill: "#6B7F74",
    textAnchor: "middle",
    fontFamily: "Consolas, monospace"
  }, "hint_ttl 3600s &#183; negative cache 60s"))), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 748,
    y1: 447,
    x2: 812,
    y2: 300,
    stroke: "#9AA9A1",
    strokeWidth: 1.5
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "816,296 806,300 811,308",
    fill: "#9AA9A1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgObianFig1FourLayerRouter);
export default __webpack_public_path__ + "static/media/obian-fig1-four-layer-router.db449cd4bebaa0b39a85b033141210c7.svg";
export { ForwardRef as ReactComponent };